import { Pagination }             from 'antd'
import { observer }               from 'mobx-react'
import React                      from 'react'

import { DataFetcher }            from '../02_api'


@observer
export class FetcherPagination<T> extends React.Component< { fetcher: DataFetcher<T>, page_size: number } >
{
  public render ( )
  {
    const on_set_cur_page = ( page: number ) => f.cur_page = page - 1
        , f               = this.props.fetcher
        , page_size       = this.props.page_size ;

    return f.num_pages > 1 || f.cur_page > 0?
             <Pagination onChange={ on_set_cur_page } 
                         current={ f.cur_page + 1 }
                         pageSize={ page_size }
                         total={ f.num_pages * page_size } />
           : null ;
  }
}